const PSY_URI = {
  /*配置  http://bg.fjyszn.com/qa*/
  BANNER_LIST_ON_OFFICIAL_WEBSITE:  "/api/webbanner/list",            //官网banner列表
  NEWS_DYNAMIC_LIST:"/api/webnews/list",                              // 官网新闻动态列表
  PRODUCTS_AND_SERVICES:"/api/webproductsolution/list" ,               // 官网产品与服务列表
  VIDEO_PROMOTION_LIST:"/api/webvideo/list",                             //官网视频宣传详情
  ELITE_TEAM_LIST:"/api/webteam/list",                                   //官网精英团队列表
  CUSTOMER_LIST:'/api/webourcustomers/list',                             //官网我们的客户列表
  JOIN_US_lIST:'/api/webjoinus/list',                                     //官网加入我们列表
  HONOR_lIST:'/api/webhonor/list',                                     //官网资质证书列表

  /*加入我们*/
  STAFF_ACTIVITIES:"/api/webstaffactivities/list",                       //官网员工活动列表
  OFFICE_ENVIRONMENT:"/api/webofficeenvironment/list",                    //官网办公环境列表
  /*新闻动态*/
  NEWS_CATEGORY_LIST:"/api/webnewtype/list" ,                              //官网新闻类别列表
  /*视频宣传*/
  VIDEO_CATEGORY_LIST:"/api/webvideotype/list",                            //官网视频类别列表
  /*企业理念*/
  IDEA_LIST:"/api/webenterpriseconcept/list",                               //官网企业理念列表
  /*新闻动态详情*/
  DETAILS_OF_NEWS:"/api/webnews/info/",                                       //官网新闻动态详情
  /*精英团队详情*/
  ELITE_TEAM_DETAILS:"/api/webteam/info/",                                   //精英团队详情
  /*加入我们详情*/
  POSITON_DETAIL:"/api/webjoinus/info/",                                  //官网加入我们详情
  
  PRODUCT_CATEGORY_LIST:"/api/webproducttype/list" ,                              //官网产品类别列表

  /*产品详情*/
  DETAILS_OF_PRODUCTS:"/api/webproductsolution/info/",                                       //官网产品详情
}
export default PSY_URI;
